"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cpf_cnpj_validator_1 = require("cpf-cnpj-validator");
var classes_1 = require("../../classes");
function isCnpj(value) {
  var isValid = cpf_cnpj_validator_1.cnpj.isValid(value);
  if (isValid) {
    return new classes_1.ValidationResult(true);
  } else {
    return new classes_1.ValidationResult(false, 'Formato de CNPJ inválido');
  }
}
exports.default = new classes_1.Validator(isCnpj);